import React from "react";
import logo from "@/assets/lodge-logo.png";

// Single source of truth for the Lodge & Co logo.
// `onDark` places the logo on a light circular chip so the (dark) mark stays legible
// on dark-green surfaces. Proportions are preserved (w-auto, object-contain).
export const Logo = ({ className = "h-11 lg:h-[52px]", onDark = false }) => {
  const img = (
    <img src={logo} alt="Lodge & Co" className={`w-auto object-contain ${className}`} />
  );
  if (onDark) {
    return (
      <span className="inline-flex items-center justify-center rounded-full bg-white p-0.5">
        {img}
      </span>
    );
  }
  return img;
};
